/* istanbul ignore file */
/**
 *
 * @param {Array<Object>} children
 * @param {string} childName
 * @returns {Object|undefined}
 */
export default function getParentByChildName(children, childName) {
  return children.find((child) => child.name === childName || (child.children?.length && !!getParentByChildName(child.children, childName)));
}
